import React from 'react';
import { Form, Button, Input } from 'antd';
import axios from '../../../utils/AxiosUtil';
import { modalHint } from '../../../components/reqAndHint';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom'
import zxcvbn from 'zxcvbn';
import './style/setting.less'
import { useSelector } from 'react-redux'

// 个人设置
export default function Settings() {
    const langValue = useSelector(state => state.langList.value)
    let history = useHistory();

    const [updatePwdForm] = Form.useForm();
    let uid = sessionStorage.getItem('uid');

    //修改密码，点击按钮
    function updatePwdOnFinish(values) {
        values.uid = uid;
        // console.log("update-account form onFinish:", values);
        axios.post('/fund/personal/updatePwd', values).then((data) => {
            modalHint('success', data.data.msg,
                // () => resetFormFields(updatePwdForm));
                //修改成功，需要重新登录
                () => history.push('/login'), sessionStorage.clear());

        }).catch((e) => {
            modalHint('error', e.response.data.msg);
        });
    }

    const [strengthLevel, setStrengthLevel] = useState(0); // 密码强度等级

    const newPasswordOnChange = (value) => {
        let pwd = value.target.value;
        // console.log(pwd);
        // console.log(pwd.length);

        if (pwd.length >= 6) {
            let strength_level = zxcvbn(pwd).guesses_log10;
            // console.log('strength_level:', strength_level);
            setStrengthLevel(strength_level);
        } else {
            setStrengthLevel(0);
        }
    }


    return (
        <div className='change_password'>

            <h1 className="change_password_title">{langValue==0?'修改密码 Change Password':(langValue==1?'修改密码':'Change Password')}</h1>

            <div className='change_password_content'>
                <Form
                    name="update-pwd"
                    form={updatePwdForm}
                    onFinish={updatePwdOnFinish}
                    layout='vertical'
                    className='change_password_form'
                >

                    <div className={langValue==0?'info_part style1':(langValue==1?'info_part':'info_part style2')}>
                        <div className='info_text' style={{marginLeft:'40px'}}>{langValue==0?'原密码Old password':(langValue==1?'原密码':'Old password')}：</div>
                        <div className='info_value'>
                            <Form.Item
                                name="oldPassword"
                                rules={[{ required: true, message: '请输入原密码' }]}
                            >
                                <Input.Password
                                    placeholder={langValue==0?'请输入Please enter':(langValue==1?'请输入':'Please enter')}
                                    id="oldPassword"
                                    size='large'
                                    iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                />
                            </Form.Item>
                        </div>
                    </div>

                    <div className={langValue==0?'info_part style1':(langValue==1?'info_part':'info_part style2')}>
                        <div className='info_text' style={{marginLeft:'40px'}}>{langValue==0?'新密码New password':(langValue==1?'新密码':'New password')}：</div>
                        <div className='info_value'>
                            <Form.Item
                                name="newPassword"
                                rules={[{ required: true, message: '请输入新密码' },
                                // { min: 6, message: '长度不小于6个字符', trigger: 'blur' },
                                { pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,16}$/, message: '需要6~16位，并且包含数字和字母' }]}
                            >
                                <Input.Password
                                    placeholder={langValue==0?'请输入Please enter':(langValue==1?'请输入':'Please enter')} id="newPassword"
                                    onChange={newPasswordOnChange}
                                    size='large'
                                    iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                />
                            </Form.Item>
                        </div>
                    </div>

                    <div className="info_part_strength">
                        <div className='info_text'></div>
                        <div className='info_value'>
                            <meter min="0" max="12" low="4" high="8" optimum="10" value={strengthLevel}></meter>
                        </div>
                    </div>

                    <div className={langValue==0?'info_part style1':(langValue==1?'info_part':'info_part style2')}>
                        <div className='info_text'>{langValue==0?'确认新密码Confirm new password':(langValue==1?'确认新密码':'Confirm new password')}：</div>
                        <div className='info_value'>
                            <Form.Item
                                name="confirmPassword"
                                dependencies={['newPassword']}
                                rules={[{ required: true, message: '请确认新密码' },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('newPassword') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('两次输入的密码不一致'));
                                    },
                                })]}
                            >
                                <Input.Password
                                    placeholder={langValue==0?'请输入Please enter':(langValue==1?'请输入':'Please enter')}
                                    id="confirmPassword"
                                    size='large'
                                    iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                />
                            </Form.Item>
                        </div>
                    </div>

                    <div className="info_part">
                        <div className='info_text'></div>
                        <Button
                            type="primary"
                            htmlType="submit"
                            className='btn'
                        >{langValue==0?'保存Save':(langValue==1?'保存':'Save')}
                        </Button>
                    </div>

                </Form>

            </div>

        </div>

    )
}
